var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard" },
    [
      _c("div", { staticClass: "container" }, [
        _c("header", { staticClass: "dashboard__hero" }, [
          _c("div", { staticClass: "dashboard__hero-brand" }, [
            _c("div", [
              _c("p", { staticClass: "dashboard__eyebrow" }, [
                _vm._v(_vm._s(_vm.$t("pages.dashboard.title"))),
              ]),
              _vm.webUser
                ? _c("h1", { staticClass: "dashboard__title" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("pages.dashboard.greeting")) +
                        ", " +
                        _vm._s(_vm.webUser) +
                        " "
                    ),
                  ])
                : _c("h1", { staticClass: "dashboard__title" }, [
                    _vm._v(_vm._s(_vm.$t("pages.dashboard.title"))),
                  ]),
            ]),
          ]),
          _c("div", { staticClass: "dashboard__date" }, [
            _c("i", {
              staticClass: "far fa-calendar-alt",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" " + _vm._s(_vm.todayLabel) + " "),
          ]),
        ]),
        _c("section", { staticClass: "dashboard__section" }, [
          _c(
            "div",
            { staticClass: "dashboard__widgets" },
            [
              _c("responsible-pay-roll-for-sign-widget", {
                staticClass: "dashboard__widget",
              }),
              _c("employee-working-widget", {
                staticClass: "dashboard__widget",
              }),
              _c("employee-vacations-widget", {
                staticClass: "dashboard__widget",
              }),
              _c("employee-sick-widget", { staticClass: "dashboard__widget" }),
              _c("employee-resting-widget", {
                staticClass: "dashboard__widget",
              }),
              _c("confirm-waiting-absence-widget", {
                staticClass: "dashboard__widget",
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("section", { staticClass: "dashboard__section" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "dashboard__section-head" }, [
            _c("h2", { staticClass: "dashboard__section-title" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("pages.dashboard.responsible.plan_employees")) +
                  " "
              ),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "dashboard__panel plan dashboard__panel--bleed" },
          [
            _c("plan-component", {
              attrs: { defaultType: _vm.typeDayCalendar },
            }),
          ],
          1
        ),
      ]),
      _c("work-shift-detail-modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }